import React, { useCallback, useEffect } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";

declare global {
  interface Window {
    CKEDITOR: any; // You might want to use a more specific type if available
  }
}

const editorConfiguration = {
  removePlugins: [
    // These two are commercial, but you can try them out without registering to a trial.
    // 'ExportPdf',
    // 'ExportWord',
    "AIAssistant",
    "CKBox",
    "CKFinder",
    "EasyImage",
    // This sample uses the Base64UploadAdapter to handle image uploads as it requires no configuration.
    // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/base64-upload-adapter.html
    // Storing images as Base64 is usually a very bad idea.
    // Replace it on production website with other solutions:
    // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/image-upload.html
    // 'Base64UploadAdapter',
    "RealTimeCollaborativeComments",
    "RealTimeCollaborativeTrackChanges",
    "RealTimeCollaborativeRevisionHistory",
    "PresenceList",
    "Comments",
    "TrackChanges",
    "TrackChangesData",
    "RevisionHistory",
    "Pagination",
    "WProofreader",
    // Careful, with the Mathtype plugin CKEditor will not load when loading this sample
    // from a local file system (file://) - load this site via HTTP server if you enable MathType.
    "MathType",
    // The following features are part of the Productivity Pack and require additional license.
    "SlashCommand",
    "Template",
    "DocumentOutline",
    "FormatPainter",
    "TableOfContents",
    "PasteFromOfficeEnhanced",
  ],
  toolbar: [
    "undo",
    "redo",
    "|",
    "heading",
    "|",
    "highlight",
    "|",
    "bulletedList",
    "numberedList",
    "link",
    "|",
    "bold",
    "italic",
  ],
  link: {
    decorators: {
      openInNewTab: {
        mode: "manual",
        label: "Open in a new tab",
        defaultValue: true,
        attributes: {
          target: "_blank",
          rel: "noopener noreferrer",
        },
      },
    },
  },
};

export const Wysiwyg = (props: WysiwygProps) => {
  const { savedData = "", onChange, disabled } = props;

  const [wipData, setWipData] = React.useState<string>(savedData);

  const handleOnChange = useCallback(
    (data: string) => {
      if (data !== savedData) {
        onChange(data);
        setWipData(data);
      }
    },
    [savedData, onChange]
  );

  useEffect(() => setWipData(savedData), [savedData]);

  return (
    <CKEditor
      editor={window.CKEDITOR.ClassicEditor}
      data={wipData}
      onChange={(_event: unknown, editor: { getData: () => string }) => handleOnChange(editor.getData())}
      config={editorConfiguration}
      disabled={disabled}
    />
  );
};

interface WysiwygProps {
  savedData?: string;
  onChange: (data: string) => void;
  disabled?: boolean;
}
